import DegreeModel from './degree.model';
export default class DegreeList {
  constructor() {
    this._degrees = [];
    this._activeDegree = null;
  }

  set degrees(degreeList) {
    this._degrees = [];
    degreeList.forEach((degreeInfo) => {
      this._degrees.push(new DegreeModel(degreeInfo));
    });
    this._preloadImages();
  }

  get degrees() {
    return {
      degrees: this._degrees
    };
  }

  _preloadImages() {
    this._degrees.forEach((degree) => {
      let imgActive = new Image(),
        imgPassive = new Image();
      imgActive.src = degree._degreeImageLocationUrlPassive;
      imgPassive.src = degree._degreeImageLocationUrlActive;
    });
  }

  set activeDegree(activeDegree) {
    this._activeDegree = activeDegree;
  }

  get activeDegree() {
    return this._activeDegree;
  }
}
